export default __webpack_public_path__ + "static/media/tas-check-fill.2b9bdcd2.svg";